import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HeaderService } from './header.service';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class VisaReportService {

  constructor(private http: HttpClient, private headerService: HeaderService, private authService: AuthService) { }

  getShipReportsByDate(data: object) {
    let httpParams = new HttpParams();
    const keys = Object.keys(data);
    for (const prop of keys) {
      if (data[prop]) {
        httpParams = httpParams.append(prop.trim(), data[prop].trim());
      } else {
        httpParams = httpParams.append(prop.trim(), '');
      }
    }
    const url = `${environment.rootApiUrl}/reports/ship/search/visaReports`;

    return this.http.post(url, {}, { headers: this.headerService.getXAuthHeaderFromCookie(), params: httpParams });
  }
}
